// import React from "react";
// import "./style.scss";

// const BargainingAlert: React.FC<{
//   variant: "info" | "danger" | "warning";
//   text: string;
// }> = ({ variant = "info", text }) => {
//   return (
//     <div className={"bargaining-alert" + " " + variant}>
//       <span className={variant}>{text}</span>
//     </div>
//   );
// };

// export default BargainingAlert;
import React from "react";
import { useNavigate } from "react-router-dom";
import "./style.scss";
import { PATH_LIST } from "shared/lib/react-router";

// Map of trigger phrases to match
const TRIGGER_PHRASES = ["contact us", "կապ հաստատել", "свяжитесь с нами"];

const BargainingAlert: React.FC<{
  variant: "info" | "danger" | "warning";
  text: string;
}> = ({ variant = "info", text }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(PATH_LIST.chat);
  };

  const renderText = () => {
    const trigger = TRIGGER_PHRASES.find((phrase) =>
      text.toLowerCase().includes(phrase.toLowerCase())
    );

    if (!trigger) return <span className={variant}>{text}</span>;

    const regex = new RegExp(`(${trigger})`, "i");
    const parts = text.split(regex);

    return (
      <span className={variant}>
        {parts.map((part, index) => {
          if (part.toLowerCase() === trigger.toLowerCase()) {
            return (
              <span
                style={{
                  textDecoration: "underline",
                  color: "black",
                  cursor: "pointer",
                }}
                key={index}
                className="contact-link"
                onClick={handleClick}
              >
                {part}
              </span>
            );
          }
          return <React.Fragment key={index}>{part}</React.Fragment>;
        })}
      </span>
    );
  };

  return <div className={`bargaining-alert ${variant}`}>{renderText()}</div>;
};

export default BargainingAlert;
